import { render, staticRenderFns } from "./backgroundSetting.vue?vue&type=template&id=45a826ca&scoped=true"
import script from "./backgroundSetting.vue?vue&type=script&lang=js"
export * from "./backgroundSetting.vue?vue&type=script&lang=js"
import style0 from "./backgroundSetting.vue?vue&type=style&index=0&id=45a826ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a826ca",
  null
  
)

export default component.exports